import * as React from 'react';
import sanitizeHtml from 'sanitize-html';
import { IPost } from '../../types';

interface IProps {
	post: IPost;
}

const Partner = ({ post }: IProps) => {
	const linkText = `Visit Partner Site`;

	return (
		<a
			href={post.permalink}
			target="_self"
			rel="noreferrer"
			className="pfa-card-default pfa-card-default--partner"
		>
			{!!post.featured_image && (
				<figure
					className="pfa-card-default__img-wrapper"
					dangerouslySetInnerHTML={{ __html: post.featured_image }}
				/>
			)}
			<div className="pfa-card-default__text">
				<div className="pfa-card-default__content">
					{post.post_title && (
						<h3
							className="pfa-card-default__title"
							dangerouslySetInnerHTML={{ __html: sanitizeHtml(post.post_title) }}
						/>
					)}
					<p>
						{post?.city_state}, {post?.engagement}, {post?.type}
					</p>
				</div>
				<div className="pfa-card-default__link btn-tertiary">
					<div className="btn-frame">
						<span className="btn-inner">{linkText}</span>
					</div>
				</div>
			</div>
		</a>
	);
};

Partner.displayName = 'Partner';

export default Partner;
